import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-gamepad-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-semibold text-background-50 font-heading">
                  PG国际008
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                PG国际下载008官方正版，提供最新版本极速安装包，支持iOS与Android全平台下载，安全无毒，一键安装。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/slots" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">游戏分类</Link></li>
                <li><Link to="/articles" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">攻略资讯</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">热门分类</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/category/slots" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">老虎机游戏</Link></li>
                <li><Link to="/category/board" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">棋牌游戏</Link></li>
                <li><Link to="/category/fishing" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">捕鱼游戏</Link></li>
                <li><Link to="/category/sports" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">体育电竞</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line"></i>
                  <span>service@pgjixz008.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-customer-service-2-line"></i>
                  <span>24小时在线客服</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-shield-check-line"></i>
                  <span>安全认证 · 官方正版</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2026 PG国际下载008. 保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500">友情链接：</span>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">PG国际008</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">PG游戏下载</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}